import CityPageTemplate from "../city-template/CityPageTemplate";
import { findlayConfig } from "./data";

export default function FindlayPage() {
  return <CityPageTemplate config={findlayConfig} />;
}